import { create } from 'zustand';

type Tab = 'study-types' | 'required-study' | 'tahseel-study-type' | 'measurement-points';

interface PledgeStudyConfigStore {
  activeTab: Tab;
  showCreate: boolean;
  editStudyType: unknown | null;
  deleteConfirm: string | null;
  showAdd: boolean;
  editPoint: unknown | null;
  showCreateRequiredStudy: boolean;
  editRequiredStudy: unknown | null;
  deleteConfirmRequiredStudy: string | null;
  showCreateTahseelStudyType: boolean;
  editTahseelStudyType: unknown | null;
  deleteConfirmTahseelStudyType: string | null;
  setActiveTab: (tab: Tab) => void;
  setShowCreate: (open: boolean) => void;
  setEditStudyType: (t: unknown | null) => void;
  setDeleteConfirm: (id: string | null) => void;
  setShowAdd: (open: boolean) => void;
  setEditPoint: (p: unknown | null) => void;
  setShowCreateRequiredStudy: (open: boolean) => void;
  setEditRequiredStudy: (t: unknown | null) => void;
  setDeleteConfirmRequiredStudy: (id: string | null) => void;
  setShowCreateTahseelStudyType: (open: boolean) => void;
  setEditTahseelStudyType: (t: unknown | null) => void;
  setDeleteConfirmTahseelStudyType: (id: string | null) => void;
}

export const usePledgeStudyConfigStore = create<PledgeStudyConfigStore>((set) => ({
  activeTab: 'study-types',
  showCreate: false,
  editStudyType: null,
  deleteConfirm: null,
  showAdd: false,
  editPoint: null,
  showCreateRequiredStudy: false,
  editRequiredStudy: null,
  deleteConfirmRequiredStudy: null,
  showCreateTahseelStudyType: false,
  editTahseelStudyType: null,
  deleteConfirmTahseelStudyType: null,
  setActiveTab: (tab) => set({ activeTab: tab }),
  setShowCreate: (open) => set({ showCreate: open }),
  setEditStudyType: (t) => set({ editStudyType: t }),
  setDeleteConfirm: (id) => set({ deleteConfirm: id }),
  setShowAdd: (open) => set({ showAdd: open }),
  setEditPoint: (p) => set({ editPoint: p }),
  setShowCreateRequiredStudy: (open) => set({ showCreateRequiredStudy: open }),
  setEditRequiredStudy: (t) => set({ editRequiredStudy: t }),
  setDeleteConfirmRequiredStudy: (id) => set({ deleteConfirmRequiredStudy: id }),
  setShowCreateTahseelStudyType: (open) => set({ showCreateTahseelStudyType: open }),
  setEditTahseelStudyType: (t) => set({ editTahseelStudyType: t }),
  setDeleteConfirmTahseelStudyType: (id) => set({ deleteConfirmTahseelStudyType: id }),
}));
